import React, {useEffect, useState,Fragment, useCallback, useContext} from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import localization from 'assets/localization/localization';
import {Button} from "react-bootstrap";
import Images from 'assets/images/imageData';
import {BaseUrl} from "../../../contexts/baseUrl/baseUrl";
import MrfFilters from 'components/sales/ListFilters/MrfFilter';

const MrfListing = ({
                        getPending,
                        pendingListing,
                        match,
                        history,
                        fetchRmTicket,
                        rmTicketFilter,
                        getRmTicketsFilterDropDown,
                    }) => {


    const [listData, setListData] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const {baseUrl} = useContext(BaseUrl);
    const [showFilter, setShowFilter] = useState(false);
    const [filterData, setFilterData] = useState(null);

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            getPending(1, match.params.list_type, null)
            setIsLoading(false)
        })()
    }, []);

    const applyFilter = async (filterData) => {
        setIsLoading(true);
        localStorage.setItem("mrf_filter", JSON.stringify(filterData));
        setFilterData(filterData);
        await getPending(1,match.params.list_type,filterData);
        setIsLoading(false);
        filterToggle();
    };

    const headers = [
        'MRF ID',
        'Site Number',
        'Site',
        'Material Type',
        'Planned Delivery Date',
        'Scope',
        'Status',
        'Created By',
        'Created At',
        'Assigned To',
        'Actions'
    ];

    useEffect(() => {
        if (pendingListing && pendingListing?.data && pendingListing?.data.length > 0) {
            const tableData = ['id','mrf_id','site_no','client_name', 'material_acquisition_type', 'planned_delivery_date', 'scope', 'status', 'created_by', 'created_at', 'approval'];
            const action = [{name: 'View Material', link: '/dashboard/view-mrf/' + match.params.list_type}];
            const data = pendingListing?.data.map((element) =>
                Object.assign(
                    ...tableData.map((key) => (
                        key === 'created_by' ? {['created_by']: element?.created_by?.name} :
                            key === 'material_acquisition_type' ? {['material_type']: element?.material_acquisition_type?.name !== undefined ? element?.material_acquisition_type?.name : 'Installation'} :
                                key === 'status' && parseInt(element['approval_status']) === 0 ? {[key]: 'Pending'} :
                                    key === 'status' && parseInt(element['approval_status']) === 1 ? {[key]: 'Approved'} :
                                        key === 'status' && parseInt(element['approval_status']) === 2 ? {[key]: 'Rejected'} :
                                            key === 'approval' && element?.requested_to?.name === undefined ? {[key] : 'In Store'} :
                                            key === 'approval' && parseInt(element['approval_status'])  === 1 &&
                                            element?.requested_to.name !== undefined ? {[key] : 'In Store'} :
                                                key === 'approval' &&
                                                element?.requested_to.name !== undefined ? {[key]: element?.requested_to?.name} :
                                            {[key]: element[key]}
                    )),
                    {},
                    {Action: action}
                )
            )
            if (data) {
                data && setListData(data);
            }
            setPageCount(Math.ceil(pendingListing.total / pendingListing.per_page));
        }
    }, [pendingListing])

    const onPageChange = async (val) => {
        setIsLoading(true);
        await getPending(val.selected + 1, match.params.list_type);
        // let filter = filterData === null ? null : filterData;
        setIsLoading(false);
    };

    const mrfCreate = () => {
        history.push(`${baseUrl}/mrf`);
    }

    const filterToggle = () => {
        setShowFilter(!showFilter);
      };

    const headerBtns = () => {
        return (
            <>
                {match.params.list_type === '2' &&
                    <Button
                        onClick={mrfCreate}
                        className="filter-hamburger btn btn-transparent filter-btn-dir filters_direction filters-section"
                    >
                        <b className="site_filters" style={{width: "max-content"}}>
                            {localization.materialAcquisition}
                        </b>
                    </Button>
                }

                <Fragment>
                    <Button
                    onClick={filterToggle}
                    className="filter-hamburger btn btn-transparent"
                    >
                    <img src={Images?.Filter} alt=""></img>
                    {localization.showFilters}
                    </Button>
                </Fragment>
            </>
        );
    };

    return (
        <Layout
            title={localization.materialAcquisition}
            isLoading={isLoading}
            isGoback={true}
            Buttons={headerBtns}
        >
            <TableSection
                data={listData}
                isId={false}
                isMngId={false}
                headers={headers}
                pageCount={pageCount}
                onPageChange={onPageChange}
                detailList={pendingListing && pendingListing.data}
                srNo={pendingListing?.from}
            />
            <MrfFilters
                showFilter={showFilter}
                filterToggle={filterToggle}
                applyFilter={(val) => applyFilter(val)}
                statusId={0}
                listFilterData={rmTicketFilter?.sites ? rmTicketFilter : null}
                rmTicketFilter
            />
        </Layout>
    )
}

export default MrfListing